import i18n from 'i18next';
import languagedetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Language from 'constants/language';
import initializeDayjs from 'utils/date/initializeDayjs';
import en from '../locale/en.json';
import no from '../locale/no.json';
i18n.use(languagedetector).use(initReactI18next).init({
  resources: {
    en: {
      common: en
    },
    no: {
      common: no
    },
    nb: {
      common: no
    }
  },
  fallbackLng: Language.norwegianBokmal,
  ns: ['common'],
  defaultNS: 'common',
  fallbackNS: ['common'],
  returnObjects: true,
  interpolation: {
    escapeValue: false,
    formatSeparator: ','
  },
  react: {
    useSuspense: true
  },
  load: 'languageOnly',
  supportedLngs: [Language.norwegianBokmal, Language.norwegian, Language.english]
});
initializeDayjs(i18n.languages[0]);
export default i18n;